
import * as FieldActions from './actions';
import { createReducer, on, Action } from '@ngrx/store';
import { State } from './state';
import { IField } from '@app/models/field.model';
import { entityAdapter } from '@app/root-store/adapter';

const adapter = entityAdapter<IField>();

export const initialState = adapter.getInitialState({searchText: ''});

const reducer = createReducer(
  initialState,
  on(FieldActions.GetFieldsAction, state => state),
  on(FieldActions.BeginUpdateFieldAction, state => state),
  on(FieldActions.GetFieldsByProjectAction, state => state),
  on(FieldActions.BeginCreateFieldAction, state => state),
  on(FieldActions.BeginRemoveFieldAction, state => state),
  on(FieldActions.SuccessCreateFieldAction, (state: State, { payload }) => adapter.addOne(payload, state)),
  on(FieldActions.AddFieldsAction, (state: State, { payload }) => adapter.addMany(payload.fields, state)),
  on(FieldActions.RemoveFieldAction, (state: State, { payload }) => adapter.removeOne(payload._id, state)),
  on(FieldActions.UpdateFieldAction, (state: State, { payload }) => {
    return adapter.updateOne({id: payload._id, changes: payload}, state);
  }),

  on(FieldActions.FieldsLoadedAction, (state: State, { payload }) => {
    return adapter.setAll(payload.fields, {
      ...state
    });
  }),

  on(FieldActions.GetLibraryFieldsAction, state => state),
  on(FieldActions.LibraryFieldsLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      libraryFields: [...payload.fields]
    };
  }),
  on(FieldActions.GetAllFieldsAction, state => state),
  on(FieldActions.AllFieldsLoadedAction, (state: State, { payload }) => {
    return adapter.setAll(payload.fields, {
      ...state
    });
  }),
  on(FieldActions.SetSearchTextAction, (state: State, { payload }) => {
    return {
      ...state,
      searchText: payload
    };
  }),
);

export function FieldReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal,
} = adapter.getSelectors();
